module.exports = __webpack_public_path__ + "img/s-1.f210d29d.png";